import { IoReturnDownBack } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { FC } from 'react';
import classes from '@/shared/ui/ActionButton/IconActionButton.module.scss';

interface BackButtonProps {
    url?: string;
    title?: string;
    className?: string;
    size?: 'small' | 'normal';
}

/** Возвращает к указанному маршруту или к предыдущей странице. */
export const BackButton: FC<BackButtonProps> = (
    {
        url,
        title = "Вернуться назад",
        className = '',
        size = 'normal'
    }
) => {
    const navigate = useNavigate();

    /** Возвращает сотрудника на предыдущую страницу */
    const handleClick = () => {
        if (url) {
            navigate(url);
        } else {
            navigate(-1);
        }
    };

    return (
        <Button
            title={title}
            aria-label={title}
            className={[classes.iconActionButton, size === 'small' && classes.small, className].filter(Boolean).join(' ')}
            onClick={handleClick}
        >
            <IoReturnDownBack aria-hidden="true" />
        </Button>
    );
};
